// extracted by mini-css-extract-plugin
export default {"contentWrapper":"content_contentWrapper__kfS7G"};